module.exports = __webpack_public_path__ + "static/media/back-login.cc050c43.jpg";